;(function () {
  angular
    .module('contrast.services.key.status')
    .directive('keyStatusRotated', function () {
      'ngInject'

      return {
        restrict: 'A',
        scope: {
          keyStatusRotated: '='
        },
        link: function (scope, element) {
          var className = 'key-status-rotated'
          function toggle(bool) {
            bool ? element.addClass(className) : element.removeClass(className)
          }
          scope.$watch('keyStatusRotated', toggle)
          toggle(scope.keyStatusRotated)
        }
      }
    })
})()
